import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { getGradient } from '@twistopayments/design-system/theme';

import { styledEndAdornment } from '../action/action-content.styles';

export const root = (theme: Theme) => css`
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing[8]} ${theme.spacing[16]};
  font-weight: inherit;
  width: 100%;

  &:disabled {
    opacity: 1;
  }
`;

export const clickable = (theme: Theme) => css`
  cursor: pointer;

  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    background: ${getGradient(theme, 'linearGray')};
  }
`;

export const shadowInput = css`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
`;

export const disabled = css`
  pointer-events: none;

  ${styledEndAdornment} {
    pointer-events: initial;
  }
`;
